import { CustomFieldTypeEnum } from 'src/app/enum/custom-field-type.enum';

export class FormCustomField {
  stamp: string;
  signatoryId: string;
  fileName: string;
  page: string;
  positionX: number;
  positionY: number;
  positionPixelX: number;
  positionPixelY: number;
  invalid: boolean;
  gId: string;
  default: boolean = false;
  fieldType: CustomFieldTypeEnum;
  displayName: string;
  fontSize: number;
  required: boolean;
  sizeWidth: number;
  sizeHeight: number;
  sizePixelWidth: number;
  sizePixelHeight: number;
  value: string;
  numberOfLines?: number;
  isNew?: boolean;
}
